import DiagnosticsPage from '@/views/profile/DiagnosticsPage'

export default function DiagnosticsScreen() {
  return <DiagnosticsPage />
}
